import { createFileRoute } from '@tanstack/react-router';

import { ForgotPasswordPage } from '../modules/auth/ui/pages/ForgotPasswordPage';

export const Route = createFileRoute('/forgot-password')({
  component: ForgotPasswordPage,
});
